import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { flowNumDetail } from '@/api/PMS/repair/repairManagement';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: ['keyValue', 'flowNum', 'showDialog'],
  data: function data() {
    return {
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      downloadUrl: '',
      listLoading: false,
      areaId: '',
      innerVisible: true,
      dialogImageUrl: '',
      dialogVisible: false,
      dataList: [],
      options: [],
      fileList: [],
      childData: {},
      pictureList: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
  },
  methods: {
    init: function init() {
      var _this = this;

      this.fileList = [];
      this.options = [];
      this.loadMenuTree();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue,
          flowNum: this.flowNum
        };
        flowNumDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.dataList = response.data.data.recordList;
          _this.fileList = response.data.data.pictureList.map(function (item) {
            var obj = {};
            obj.url = item.url;
            return obj;
          });
        });
      } else {
        this.areaId = '';
        this.childData = {};
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 4
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairDetail');
    }
  }
};